import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import languages from '../../constants/DefaultLang';

import config from '../../config';

const LangSwitcher = (props) => {
  const { i18n, siteConfig } = props;
  const curLang = i18n.locale;
  const { data = {} } = siteConfig || {};
  const { menu_config = {} } = data[i18n.locale] || {};
  const { availableLanguages } = data;

  const html = Object.keys(languages || {}).map((v, i) => {
    if (v !== curLang && availableLanguages.indexOf(v) > -1) {
      const constructURL = (location) => {
        const curRootPath = `${config.routePathTo}/${curLang}`;
        const pathname =
          location.pathname === curRootPath ||
          location.pathname === config.routePathTo ||
          location.pathname === `${config.routePathTo}/`
            ? `${config.routePathTo}/${v}`
            : location.pathname.replace(curRootPath, `${config.routePathTo}/${v}`);
        return {
          ...location,
          pathname,
        };
      };
      return (
        <NavLink to={constructURL} key={i} activeClassName="selected">
          {languages[v].short}
        </NavLink>
      );
    }
    return '';
  });

  console.log(isEmpty(menu_config));
  return (
    <>
      {html.some((v) => !!v) && (
        <div className={`${isEmpty(menu_config.menu_buttons) ? 'mobileHiddenBar' : ''} languages`}>
          {html}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  siteConfig: state.siteConfig,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(LangSwitcher);

export { LangSwitcher as LangSwitcherComponent }; // <- For component Unit Test
export default connectStore;
